import BaseStore from './baseStore';
import { FLOW_QUESTION_COMPLETED } from 'src/config/actions';

// since we are experimenting on this
// we are using the question node's
// `gtm` key for selecting the params we want to pass
// (reusing what we use for tracking)
const QUESTION_FILTER_ALLOWLIST = [
  'demo_question_motivation',
  'demo_question_source',
  'demo_question_age',
  'demo_question_previous_experience',
  'demo_question_time'
];

class QuestionStore extends BaseStore {
  constructor() {
    super();
    this.answers = {};
  }

  onDispatcherAction({ type, data }) {
    switch (type) {
      case FLOW_QUESTION_COMPLETED:
        this.setAnswer(data);
        this.emitChange();
        break;
    }
  }

  getFilteredAnswersForQuery() {
    return Object.keys(this.answers)
      .filter((key) => QUESTION_FILTER_ALLOWLIST.includes(key))
      .map((key) => `${key}=${this.answers[key].toLowerCase()}`)
      .join('&');
  }

  setAnswer({ question, answer }) {
    this.answers[question] = answer;
  }
};

export default new QuestionStore();
